import styled from "styled-components";
export const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 20px;
  list-style: none;
  background-color: #f0f2f5;
`;
